<template>
  <div>
    <div v-if="verificationStatus == 1" style="max-width: 525px;">
      <v-alert type="success" dense text border="left">
        {{ $t("verification.phone.successMessage") }}
      </v-alert>
    </div>
    <div v-if="verificationStatus == 0">
      <span>{{ $t("verification.phone.descriptionSecurityVerify.text1") }}</span>
      <br v-if="$store.state.operators.multifactor == 1" />
      <span
        v-if="$store.state.operators.multifactor == 1"
        v-html="$t('verification.phone.descriptionSecurityVerify.text2')"
      ></span>
      <br /><br />
      <span v-html="$t('verification.phone.descriptionPhoneVerify.title')"></span>
      <br />
      <span>{{ $t("verification.phone.descriptionPhoneVerify.text1") }}</span>
      <br />
      <span>{{ $t("verification.phone.descriptionPhoneVerify.text2") }}</span>
      <br />
      <div>{{ $t("verification.phone.descriptionPhoneVerify.text3") }}</div>
      <v-btn
        class="mt-6 px-8"
        color="primary"
        :block="$vuetify.breakpoint.smAndDown"
        style="text-transform: none;"
        @click.prevent="openVerifySmsPhone"
      >
        {{ $t("verification.phone.btnVerify") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhoneVerification",

  props: {
    verificationStatus: {
      type: String,
      required: true,
    },
  },

  watch: {
    showDialogVerifySmsTokenStore(dialogState) {
      if (dialogState.trigger === "phoneVerification")
        this.$emit("changePhoneVerificationStatus");
    },
  },

  computed: {
    showDialogVerifySmsTokenStore() {
      const dialogState = this.$store.getters.getDialogVerifySmsToken;

      return dialogState;
    },
  },

  methods: {
    openVerifySmsPhone() {
      this.$store.commit("setDialogVerifySmsToken", {
        status: true,
        typeVerification: "phoneVerification",
      });
    },
  },
};
</script>
